import api from './api';

const approvalWorkflowMasterService = {
  // Get all approval workflows
  getAllApprovalWorkflows: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.workflowType) queryParams.append('workflowType', params.workflowType);
      if (params.search) queryParams.append('search', params.search);

      const queryString = queryParams.toString();
      const url = `/approval-workflow-master${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching approval workflows:', error);
      throw error;
    }
  },

  // Get approval workflow by ID
  getApprovalWorkflowById: async (id) => {
    try {
      const response = await api.get(`/approval-workflow-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching approval workflow:', error);
      throw error;
    }
  },

  // Get next workflow code
  getNextWorkflowCode: async () => {
    try {
      const response = await api.get('/approval-workflow-master/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next workflow code:', error);
      throw error;
    }
  },

  // Create approval workflow
  createApprovalWorkflow: async (workflowData) => {
    try {
      const response = await api.post('/approval-workflow-master', workflowData);
      return response.data;
    } catch (error) {
      console.error('Error creating approval workflow:', error);
      throw error;
    }
  },

  // Update approval workflow
  updateApprovalWorkflow: async (id, workflowData) => {
    try {
      const response = await api.put(`/approval-workflow-master/${id}`, workflowData);
      return response.data;
    } catch (error) {
      console.error('Error updating approval workflow:', error);
      throw error;
    }
  },

  // Delete approval workflow
  deleteApprovalWorkflow: async (id) => {
    try {
      const response = await api.delete(`/approval-workflow-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting approval workflow:', error);
      throw error;
    }
  },

  // Get approval workflow statistics
  getApprovalWorkflowStats: async () => {
    try {
      const response = await api.get('/approval-workflow-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching approval workflow statistics:', error);
      throw error;
    }
  }
};

export default approvalWorkflowMasterService;

